import { render, staticRenderFns } from "./BtnSolicitarAprovacao.vue?vue&type=template&id=54cf99c3"
import script from "./BtnSolicitarAprovacao.vue?vue&type=script&lang=js"
export * from "./BtnSolicitarAprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports